import { Route } from 'react-resource-router';

export function preloadRouteComponent(route: Route) {
  if ('preload' in route.component && typeof route.component.preload === 'function') {
    route.component.preload();
  }
}
